import { differenceInDays } from 'date-fns';
import { FC, memo, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FourZeroFourComponent from 'src/components/FourZeroFourComponent';
import LicenseContext from 'src/contexts/LicenseContext';
import { DateModel } from 'src/models/DateModel';

import Presenter from './Presenter';

/**
 * V2ShipmentOrderLanes ページコンポーネント
 * レーン管理画面のロジック層
 */
const V2ShipmentOrderLanes: FC = memo(() => {
  const { startOn, endOn } = useParams();
  const navigate = useNavigate();
  const context = useContext(LicenseContext);

  useEffect(() => {
    if (!context.config?.on) return;

    if (startOn) {
      const paramsStartDateModel = new DateModel(startOn);
      let paramsEndDateModel = new DateModel(endOn);
      const dateDiff = differenceInDays(new Date(endOn), new Date(startOn));

      // 日付範囲が0日未満または30日を超える場合は同日に設定
      if (dateDiff < 0 || dateDiff > 30) {
        paramsEndDateModel = new DateModel(startOn);
      }

      if (paramsStartDateModel.isValid()) {
        void navigate(`/lanes/${paramsStartDateModel.toString()}/${paramsEndDateModel.toString()}`);
        return;
      }
    }

    // デフォルトでcontextの日付を使用
    const configOnModel = new DateModel(context.config.on);

    if (configOnModel.isValid()) {
      void navigate(`/lanes/${configOnModel.toString()}/${configOnModel.toString()}`);
      return;
    }

    void navigate('/404');
  }, [startOn, endOn, context.config, navigate]);

  // startOnがない場合は404
  if (!startOn) return <FourZeroFourComponent />;

  return <Presenter startDate={startOn} endDate={endOn} />;
});

export default V2ShipmentOrderLanes;
